import React, { memo } from 'react';
import {
  Button,
  IconBannersWarning,
  Text,
  VStack,
} from '@adc/parallax-component-library';
import i18n from '../../utilities/i18n';
import { useAppSelector } from '../../reducers/hooks';
import { Organization, UserRole } from '../../models';
import { CreateOrganizationModal } from '../modal/CreateOrganizationModal';
import {
  createOrganizationMutateOptions,
  organizationsQueryOptions,
} from '../../queryOptions';
import { useMutation, useQueryClient } from '@tanstack/react-query';

function NotFound() {
  const user = useAppSelector((state) => state.user);

  const queryClient = useQueryClient();

  const createOrganization = useMutation(
    createOrganizationMutateOptions({
      onSuccess: (organization) => {
        queryClient.setQueryData(
          organizationsQueryOptions().queryKey,
          (organizations: Organization[] | undefined) => [
            ...(organizations ?? []),
            organization,
          ],
        );
      },
    }),
  );

  return (
    <VStack alignItems="center" justifyContent="center" flex={1} gap="$2">
      <VStack alignItems="center">
        <IconBannersWarning size="XL" accentColor="$support.warning.default" />
        <Text type="$h2.strong">{i18n.t('NoOrganizations.title')}</Text>
        <Text type="$bodyBase.default" textAlign="center">
          {i18n.t('NoOrganizations.description')}
        </Text>
      </VStack>
      {user.roles?.includes(UserRole.SYSTEM_ADMIN) ? (
        <CreateOrganizationModal
          onSuccess={async (newOrganization: Organization) => {
            await createOrganization.mutateAsync({
              organization: newOrganization,
            });
          }}
          trigger={
            <Button
              onPress={() => {}}
              label={i18n.t('NoOrganizations.createOrganization')}
            />
          }
        />
      ) : (
        <Text>{i18n.t('NoOrganizations.contactAdmin')}</Text>
      )}
    </VStack>
  );
}

export default memo(NotFound);
